import styled from '@emotion/styled';
import { useErrorCount } from './SchemaError.hooks';
import { ErrorIcon } from 'radiance-ui/lib/icons';

const ErrorContainer = styled.div`
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  z-index: 9999;
  padding: 0.75rem 1.5rem;
  background-color: ${({ theme }) => theme.COLORS.error};
  color: white;
  border-radius: 0.5rem;
  display: flex;
  gap: 0.5rem;
  align-items: center;
  font-size: 1.2rem;
  opacity: 0.8;
`;

export const GlobalSchemaErrorIndicator = () => {
  const errorCount = useErrorCount();

  if (errorCount === 0) return null;

  return (
    <ErrorContainer>
      <ErrorIcon width={24} height={24} />
      {errorCount} schema error(s) on page
    </ErrorContainer>
  );
};
